import { AxiosPostRequestOptions } from '@/package';
import type { AuthApi } from '@/type';
import { apiOf } from '@/util';

export const signIn = apiOf<AuthApi.SignIn.Request, AuthApi.SignIn.Response>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/user/auth/login',
  }),
);

/** @deprecated */
export const signInGoogle = apiOf<
  AuthApi.SignInGoogle.Request,
  AuthApi.SignInGoogle.Response
>(
  new AxiosPostRequestOptions<AuthApi.SignInGoogle.Request>({
    url: '/v1/miri/user/oauth2/code',
  }),
);

/** @deprecated */
export const signInForDev = apiOf<
  { email: string },
  AuthApi.SignInGoogle.Response
>(
  new AxiosPostRequestOptions<{ email: string }>({
    url: '/v1/miri/user/auth/dev/login',
    defaultData: {
      email: import.meta.env.VITE_APP_DEV_LOGIN_EMAIL,
    },
    headers: {
      DevLoginAccessKey: import.meta.env.VITE_APP_DEV_LOGIN_ACCESS_KEY,
    },
  }),
);

export const refreshToken = apiOf<
  AuthApi.RefreshToken.Request,
  AuthApi.RefreshToken.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/user/oauth2/refresh',
  }),
);
